import { type ConfiguratorProductData, isConfiguratorProduct } from "~/domains/product/types/ProductData";
import { isProductPMA } from "~/domains/product/utils/productDescriptorUtils";
import StockIndicator, { StockLevel } from "~/domains/product/components/StockIndicator/StockIndicator";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export const LineItemStockIndicator = ({
  className,
  product,
  packEntry,
}: {
  className?: string;
  product: ProductDescriptor;
  packEntry: LineItem;
}) => {
  const quantityVisible = product.base.quantityVisible;
  return (
    <>
      {isConfiguratorProduct(product.base) ? (
        <ConfiguratorStockIndicator
          className={className}
          product={product as ProductDescriptor<ConfiguratorProductData>}
        />
      ) : quantityVisible && !isProductPMA(product) ? (
        <>
          {product.availability && packEntry.isInStock !== null ? (
            <StockIndicator.V2 className={className} level={packEntry.isInStock} />
          ) : product.isAvailabilityLoading ? (
            <CircleSpinner className={className} />
          ) : (
            <div className={className}>{"-"}</div>
          )}
        </>
      ) : (
        <div className={className}>{"-"}</div>
      )}
    </>
  );
};

const ConfiguratorStockIndicator = ({
  className,
  product,
}: {
  className?: string;
  product: ProductDescriptor<ConfiguratorProductData>;
}) => {
  const { t } = useTranslation();

  if (product.isAvailabilityLoading) {
    return <CircleSpinner className={className} />;
  }

  const leadTimeDate = product.availability?.packagingInformation[0]?.replenishmentLeadTimeDate;
  let leadTimeWeeks = null;
  if (leadTimeDate) {
    leadTimeWeeks = Math.ceil(dayjs(leadTimeDate).diff(dayjs(), "day") / 7);
  }

  if (!leadTimeWeeks) {
    return <span className={className}>{"-"}</span>;
  }

  return (
    <StockIndicator.V2
      className={className}
      level={StockLevel.NOT_IN_STOCK}
      changeText={t("cartPage.avaliability.leadWeeks", {
        count: leadTimeWeeks,
      })}
    />
  );
};
